import { useSharedAuth } from '@src/context/auth/useSharedAuth';
import { COMPANY_URL } from '@src/routes/company';
import { FaInfoCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

type DisplayNameUpdateBannerProps = {
  className?: string;
};

const DisplayNameUpdateBanner = ({ className }: DisplayNameUpdateBannerProps) => {
  // 機能を一時的に無効化（機能自体はすぐ復活できるように残している）
  return null;

  const { profile } = useSharedAuth();

  const requiresDisplayNameUpdate =
    !profile?.isTenant && profile?.companyProfile?.displayNameStatus?.requires_display_name_update;

  if (!requiresDisplayNameUpdate) {
    return null;
  }

  return (
    <div
      className={`
        bg-notification-warning-bg px-5 py-[6px]
        text-xs 
        ${className || ''}
      `}
    >
      <FaInfoCircle
        size={15}
        className='mr-3 inline text-notification-warning-icon'
      />

      <span className='lg:hidden'>
        表示名が設定されていません。コミュニティ内での交流をより円滑にするため、表示名を設定しましょう。{' '}
      </span>
      <span className='hidden lg:inline'>表示名が設定されていません。 </span>

      <Link
        to={COMPANY_URL.PROFILE}
        className='underline underline-offset-2'
      >
        表示名を変更する
      </Link>
    </div>
  );
};

export default DisplayNameUpdateBanner;
